//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
import propertyMixin from "@/components/form-designer/setting-panel/property-editor/propertyMixin";
export default {
  name: "minLength-editor",
  mixins: [i18n, propertyMixin],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  computed: {
    minLength: {
      get: function get() {
        return this.optionModel['minLength'];
      },
      set: function set(newValue) {
        if (!newValue || isNaN(newValue)) {
          this.optionModel.minLength = null;
        } else {
          this.optionModel.minLength = Number(newValue);
        }
      }
    }
  }
};